module.exports = __webpack_public_path__ + "static/campus_pro-aaf7819c9782f8f5782a66dd2b3a76f6.jpg";